import {BaseStore, globalStore} from "../../../../stem-core/state/Store";
import type {StemDate} from "../../../../stem-core/time/Date";
import {field} from "../../../../stem-core/state/StoreField.js";
import type {UserProfile} from "../../UserProfileStore";
import type {Merchant} from "../../MerchantStore";
import type {MerchantCDSProduct} from "./MerchantCDSProductStore";

@globalStore
export class CDSRequestInstance extends BaseStore("CDSRequestInstance") {
    @field("UserProfile") user: UserProfile;
    @field("Merchant") merchant: Merchant;
    @field("MerchantCDSProduct") product: MerchantCDSProduct;
    @field(Date) createdAt: StemDate;
    @field(String) url: string;
    @field(String) method: string;
    @field(String) requestPayload: string;

    @field(Number) responseCode: number;
    @field(Number) responseElapsedMs: number;
    @field(String) responsePayload: string;
    @field(Boolean) responseCdsIsSuccess: boolean;
    @field(Boolean) responseSentToOffline: boolean;
    @field(String) responseCdsMessage: string;

    @field(Object) exceptionInfo: Record<string, any>;

    getRequest() {
        return JSON.parse(this.requestPayload);
    }

    getResponse() {
        return this.responsePayload && JSON.parse(this.responsePayload);
    }
}
